/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useContext, useEffect, useState } from 'react';
import { LocationContext } from '../../context/results.context';
import {
  FormContainer,
  FormButton,
  FormCenter,
  FormDropdown,
  InputFormCenter,
  MobileFormCenter,
} from '../../components/style/styled-form.component';
import { SourceLabel } from '../../components/style/mini-card.component';
import SelectDropdown from 'react-native-select-dropdown';
import NumericInput from 'react-native-numeric-input';
import { Spacer } from '../style/spacer.component';
import { TouchableOpacity, Picker, Text } from 'react-native';

import '@expo/match-media';
import { useMediaQuery } from 'react-responsive';

export const InputComponent = ({ navigation }) => {
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };

  const [sex, onChangeSex] = React.useState("Male");
  const [age, onChangeAge] = React.useState(1);
  // const [area, onChangeLocation] = React.useState('');
  const {
    countries,
    getArea,
    retrieveCountries,
    getCountry,
    setCountryISO,
    area,
    country,
    countryISO,
  } = useContext(LocationContext);

  const ageList = [
    ...Array(200 - 0 + 1)
      .fill()
      .map((_, i) => 0 + i),
  ];

  const genderList = ['Male', 'Female'];
  const locationList = [
    'Alaska',
    'Alabama',
    'Arkansas',
    'American Samoa',
    'Arizona',
    'California',
    'Colorado',
    'Connecticut',
    'District of Columbia',
    'Delaware',
    'Florida',
    'Georgia',
    'Guam',
    'Hawaii',
    'Iowa',
    'Idaho',
    'Illinois',
    'Indiana',
    'Kansas',
    'Kentucky',
    'Louisiana',
    'Massachusetts',
    'Maryland',
    'Maine',
    'Michigan',
    'Minnesota',
    'Missouri',
    'Mississippi',
    'Montana',
    'North Carolina',
    ' North Dakota',
    'Nebraska',
    'New Hampshire',
    'New Jersey',
    'New Mexico',
    'Nevada',
    'New York',
    'Ohio',
    'Oklahoma',
    'Oregon',
    'Pennsylvania',
    'Puerto Rico',
    'Rhode Island',
    'South Carolina',
    'South Dakota',
    'Tennessee',
    'Texas',
    'Utah',
    'Virginia',
    'Virgin Islands',
    'Vermont',
    'Washington',
    'Wisconsin',
    'West Virginia',
    'Wyoming',
  ];
  const countryList = countries.map((country) => country.country);
  const iso = countries.map((country) => country.countryInfo.iso3);
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

  return (
    <FormContainer>
      <FormCenter>
        <InputFormCenter>
          <Text>Sex</Text>
          <Picker
            selectedValue={sex}
            style={{ padding: 20, backgroundColor: '#ebebeb', border: 0 }}
            placeholder="Select your country"
            // placeholderStyle={{ color: '#007aff' }}
            // placeholderIconColor="#007aff"
            onValueChange={(selectedItem, index) => {
              onChangeSex(selectedItem);
            }}>
            {genderList.map((c, i) => {
              return <Picker.Item key={i} label={c} value={c} />;
            })}
          </Picker>
        </InputFormCenter>

        <Spacer position="top" size="medium">
          <InputFormCenter>
            <Text>Country</Text>
            <Picker
              selectedValue={country}
              style={{ padding: 20, backgroundColor: '#ebebeb', border: 0 }}
              placeholder="Select your country"
              // placeholderStyle={{ color: '#007aff' }}
              // placeholderIconColor="#007aff"
              onValueChange={(selectedItem, index) => {
                getCountry(selectedItem);
                setCountryISO(iso[index]);
              }}>
              {countryList.map((c, i) => {
                return <Picker.Item key={i} label={c} value={c} />;
              })}
            </Picker>
          </InputFormCenter>
        </Spacer>

        {country == 'USA' && (
          <Spacer position="top" size="medium">
            <InputFormCenter>
              <Text>State</Text>
              <Picker
                selectedValue={area}
                style={{ padding: 20, backgroundColor: '#ebebeb', border: 0 }}
                placeholder="Select your state"
                // placeholderStyle={{ color: '#007aff' }}
                // placeholderIconColor="#007aff"
                onValueChange={(selectedItem, index) => {
                  getArea(selectedItem);
                }}>
                {locationList.map((c, i) => {
                  return <Picker.Item key={i} label={c} value={c} />;
                })}
              </Picker>
            </InputFormCenter>
          </Spacer>
        )}

        <Spacer position="top" size="large">
          {/* <InputFormCenter>
            <NumericInput
              value={age}
              onChange={onChangeAge}
              onLimitReached={(isMax, msg) => console.log(isMax, msg)}
              totalWidth={300}
              totalHeight={50}
              iconSize={25}
              step={1}
              valueType="real"
              minValue={1}
              iconStyle={{ color: '#59bfb5' }}
            />
          </InputFormCenter> */}
          <InputFormCenter>
            <Text>Age</Text>
            <Picker
              selectedValue={age}
              style={{ padding: 20, backgroundColor: '#ebebeb', border: 0 }}
              placeholder="Select your age"
              // placeholderStyle={{ color: '#007aff' }}
              // placeholderIconColor="#007aff"
              onValueChange={(selectedItem, index) => {
                onChangeAge(selectedItem);
              }}>
              {ageList.map((c, i) => {
                return <Picker.Item key={i} label={c} value={c} />;
              })}
            </Picker>
          </InputFormCenter>
        </Spacer>

        <FormButton
          mode="contained"
          disabled={!sex || !country}
          onPress={() => navigation.navigate('Results', { age: age, sex: sex, area: area })}>
          Next
        </FormButton>
      </FormCenter>

      <TouchableOpacity onPress={() => navigation.navigate('Sources')}>
        <Spacer position="top" size="large">
          <SourceLabel>Sources</SourceLabel>
        </Spacer>
      </TouchableOpacity>
    </FormContainer>
  );
};
